"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRecurringChargeFields = void 0;
const luxon_1 = require("luxon");
const enums_1 = require("../../enums");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const normalizeLocale = (locale) => locale.toLowerCase().slice(0, 2);
const toDateTime = (value) => {
    if (luxon_1.DateTime.isDateTime(value)) {
        return value;
    }
    return typeof value === "string"
        ? luxon_1.DateTime.fromISO(value, { zone: "utc" })
        : luxon_1.DateTime.fromJSDate(value, { zone: "utc" });
};
const EN_ORDINAL_SUFFIX = {
    zero: "th",
    one: "st",
    two: "nd",
    few: "rd",
    many: "th",
    other: "th",
};
const enOrdinalRules = new Intl.PluralRules("en", { type: "ordinal" });
const enOrdinalDay = (day) => `${day}${EN_ORDINAL_SUFFIX[enOrdinalRules.select(day)] ?? "th"}`;
const dateDayByLang = {
    fr: (day) => (day === 1 ? "1er" : String(day)),
};
const formatDateDay = (lang, day) => (dateDayByLang[lang] ?? String)(day);
const SCHEDULE_KEY_BY_INTERVAL = {
    [enums_1.ProductDonationRecurrenceInterval.OneTime]: undefined,
    [enums_1.ProductDonationRecurrenceInterval.Weekly]: "recurringScheduleWeekly",
    [enums_1.ProductDonationRecurrenceInterval.BiWeekly]: "recurringScheduleBiWeekly",
    [enums_1.ProductDonationRecurrenceInterval.Monthly]: "recurringScheduleMonthly",
    [enums_1.ProductDonationRecurrenceInterval.Quarterly]: "recurringScheduleQuarterly",
    [enums_1.ProductDonationRecurrenceInterval.Yearly]: "recurringScheduleYearly",
};
const interpolate = (template, tokens) => template.replace(/\{(\w+)\}/g, (match, key) => tokens[key] ?? match);
const buildRecurringChargeFields = (anchorDate, recurrenceInterval, locale) => {
    if (!anchorDate) {
        return {};
    }
    const scheduleKey = SCHEDULE_KEY_BY_INTERVAL[recurrenceInterval];
    if (!scheduleKey) {
        return {};
    }
    const dt = toDateTime(anchorDate);
    if (!dt.isValid) {
        return {};
    }
    const lang = normalizeLocale(locale);
    const template = (0, email_templates_1.getEmailLabels)(locale)[scheduleKey];
    const recurringChargeSchedule = interpolate(template, {
        day: formatDateDay(lang, dt.day),
        dayOrdinal: enOrdinalDay(dt.day),
        month: dt.toFormat("LLLL", { locale: lang }),
        weekday: dt.toFormat("cccc", { locale: lang }),
    });
    return { recurringChargeSchedule };
};
exports.buildRecurringChargeFields = buildRecurringChargeFields;
